import { entries, keys, values } from '../../utils/javascript'

const regionList = [
  {
    label: 'Central Region',
    value: 'CENTRAL_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'North Region',
    value: 'NORTH_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'South Region',
    value: 'SOUTH_REGION',
    latitude: null,
    longitude: null,
  },
  {
    label: 'West Region',
    value: 'WEST_REGION',
    latitude: null,
    longitude: null,
  },
]
const countryData = {
  // in: {
  //   // 'Andhra Pradesh': {
  //   //   Visakhapatnam: [],
  //   //   Vijayawada: [],
  //   //   Guntur: [],
  //   //   Nellore: [],
  //   //   Kakinada: [],
  //   //   Rajahmundry: [],
  //   //   Tirupati: [],
  //   //   Kadapa: [],
  //   //   Kurnool: [],
  //   //   Eluru: [],
  //   //   Anantapur: [],
  //   // },
  //   Karnataka: {
  //     Bangalore: [560001, 560002, 560003],
  //     Belgaum: [590001, 590002, 590003],
  //     Ramanagara: [562159],
  //     Bidadi: [562109],
  //   },
  //   Telangana: {
  //     Hyderabad: [500001, 500002, 500003],
  //     Adilabad: [504001, 504002, 504003],
  //     // Warangal: [],
  //     // Nizamabad: [],
  //     // Khammam: [],
  //     // Karimnagar: [],
  //     // Ramagundam: [],
  //     // Secunderabad: [],
  //     // Mahbubnagar: [],
  //     // Suryapet: [],
  //     // Miryalaguda: [],
  //   },
  //   Delhi: {
  //     'New Delhi': [110001, 110002, 110003, 110020],
  //   },
  //   Maharashtra: {
  //     Mumbai: [400001, 400002, 400003],
  //     Pune: [410301, 410302, 410303],
  //     // Nagpur: [],
  //     // Thane: [],
  //   },
  //   Gujarat: {
  //     Ahmedabad: [380001, 380002, 380003],
  //     Surat: [392150, 392151, 392153],
  //   },
  //   'Uttar Pradesh': {
  //     Noida: [201305],
  //   },
  //   Punjab: {
  //     Ludhiana: [141010],
  //     // Amritsar: [],
  //     // Jalandhar: [],
  //     // Patiala: [],
  //     // Bathinda: [],
  //   },
  //   Haryana: {
  //     Gurugram: [122002],
  //     // Faridabad: [],
  //     // Gurgaon: [],
  //     // Rohtak: [],
  //     // Hisar: [],
  //     // Panipat: [],
  //     // Karnal: [],
  //     // Sonipat: [],
  //     // Yamunanagar: [],
  //     // Panchkula: [],
  //     // Bhiwani: [],
  //     // Ambala: [],
  //     // Sirsa: [],
  //   },
  // },
  us: {
    Arizona: {
      Mesa: ['85201', '85202', '85203', '85204', '85205', '85206', '85207'],
      Phoenix: [
        '85003',
        '85004',
        '85008',
        '85012',
        '85016',
        '85018',
        '85032',
        '85033',
        '85035',
      ],
      Tucson: ['85701', '85705', '85710', '85711', '85719', '85745', '85746'],
    },
    California: {
      Fresno: ['93701', '93702', '93703', '93704', '93705', '93710', '93711'],
      'Long Beach': [
        '90802',
        '90803',
        '90804',
        '90805',
        '90806',
        '90807',
        '90808',
      ],
      'Los Angeles': [
        '90001',
        '90004',
        '90012',
        '90024',
        '90026',
        '90036',
        '90049',
        '90034',
        '90035',
        '90064',
        '90066',
        '90077',
        '90210',
        '91316',
        '90028',
        '90045',
      ],
      Oakland: ['94601', '94602', '94605', '94606', '94607', '94610', '94611'],
      Sacramento: [
        '95814',
        '95815',
        '95816',
        '95817',
        '95818',
        '95819',
        '95820',
      ],
      'San Diego': [
        '92101',
        '92102',
        '92103',
        '92104',
        '92109',
        '92122',
        '92130',
      ],
      'San Francisco': [
        '94102',
        '94103',
        '94107',
        '94110',
        '94114',
        '94117',
        '94121',
        '94131',
        '94133',
      ],
      'San Jose': [
        '95112',
        '95123',
        '95124',
        '95125',
        '95126',
        '95129',
        '95132',
      ],
      Irvine: ['92602', '92603', '92604', '92606', '92612', '92620', '92614'],
    },
    Colorado: {
      Aurora: ['80010', '80011', '80012', '80013', '80014', '80015'],
      'Colorado Springs': [
        '80903',
        '80904',
        '80905',
        '80906',
        '80907',
        '80909',
        '80910',
      ],
      Denver: ['80202', '80203', '80204', '80205', '80206', '80211', '80212'],
    },
    Florida: {
      Jacksonville: [
        '32202',
        '32205',
        '32207',
        '32210',
        '32217',
        '32224',
        '32256',
        '32257',
      ],
      Miami: ['33125', '33126', '33127', '33129', '33130', '33133', '33134'],
      Orlando: ['32801', '32803', '32804', '32806', '32812', '32819', '32822'],
      Tampa: ['33602', '33603', '33604', '33606', '33607', '33609', '33611'],
      'St. Petersburg': [
        '33701',
        '33702',
        '33703',
        '33704',
        '33705',
        '33713',
        '33714',
      ],
    },
    Georgia: {
      Atlanta: ['30303', '30305', '30306', '30307', '30308', '30309', '30310'],
      Savannah: ['31401', '31404', '31405', '31406', '31410', '31419', '31411'],
    },
    Illinois: {
      Chicago: [
        '60614',
        '60618',
        '60622',
        '60640',
        '60647',
        '60657',
        '60660',
        '60619',
        '60620',
        '60628',
        '60637',
        '60643',
        '60611',
        '60654',
      ],
      Naperville: ['60540', '60563', '60564', '60565', '60566', '60567'],
    },
    Indiana: {
      Indianapolis: [
        '46202',
        '46205',
        '46220',
        '46222',
        '46237',
        '46240',
        '46250',
      ],
    },
    Massachusetts: {
      Boston: ['02108', '02109', '02114', '02115', '02116', '02118', '02120'],
      Cambridge: ['02138', '02139', '02140', '02141', '02142', '02143'],
    },
    Michigan: {
      Detroit: ['48201', '48202', '48203', '48204', '48206', '48207', '48209'],
      'Ann Arbor': ['48103', '48104', '48105', '48108', '48109', '48111'],
    },
    Nevada: {
      'Las Vegas': [
        '89101',
        '89102',
        '89103',
        '89104',
        '89106',
        '89109',
        '89117',
      ],
      Reno: ['89501', '89502', '89503', '89509', '89512', '89523'],
    },
    'New York': {
      'New York City': [
        '10001',
        '10002',
        '10009',
        '10025',
        '11211',
        '11215',
        '11368',
        '11434',
        '11375',
        '11435',
        '10451',
        '10463',
        '10301',
        '10314',
        '10011',
        '10022',
      ],
      Buffalo: ['14201', '14202', '14209', '14213', '14222', '14223'],
    },
    'North Carolina': {
      Charlotte: [
        '28202',
        '28203',
        '28205',
        '28209',
        '28210',
        '28277',
        '28211',
      ],
      Raleigh: ['27601', '27603', '27604', '27606', '27609', '27612'],
    },
    Ohio: {
      Columbus: ['43201', '43206', '43214', '43220', '43230', '43235'],
      Cleveland: ['44102', '44105', '44109', '44113', '44115', '44118'],
    },
    Pennsylvania: {
      Philadelphia: [
        '19103',
        '19104',
        '19119',
        '19123',
        '19130',
        '19147',
        '19148',
      ],
      Pittsburgh: ['15201', '15206', '15213', '15217', '15222', '15232'],
    },
    Texas: {
      Austin: ['78701', '78702', '78704', '78745', '78756', '78759', '78758'],
      Dallas: ['75201', '75204', '75206', '75214', '75219', '75230', '75248'],
      'Fort Worth': [
        '76102',
        '76107',
        '76109',
        '76110',
        '76123',
        '76133',
        '76116',
      ],
      Houston: [
        '77002',
        '77005',
        '77006',
        '77007',
        '77019',
        '77024',
        '77042',
        '77057',
        '77084',
        '77095',
        '77077',
        '77079',
      ],
      'San Antonio': [
        '78205',
        '78209',
        '78212',
        '78216',
        '78230',
        '78258',
        '78232',
      ],
      'El Paso': ['79901', '79902', '79903', '79904', '79912', '79936'],
    },
    Washington: {
      Seattle: [
        '98101',
        '98102',
        '98103',
        '98109',
        '98115',
        '98116',
        '98122',
        '98144',
      ],
      Spokane: ['99201', '99202', '99203', '99204', '99205', '99208'],
    },
  },
}

// const countryLabels = {
//   us: 'United States',
//   in: 'India',
//   ae: 'United Arab Emirates',
// }
const countryLabels = {
  af: 'Afghanistan',
  al: 'Albania',
  dz: 'Algeria',
  ad: 'Andorra',
  ao: 'Angola',
  ag: 'Antigua and Barbuda',
  ar: 'Argentina',
  am: 'Armenia',
  au: 'Australia',
  at: 'Austria',
  az: 'Azerbaijan',
  bs: 'Bahamas',
  bh: 'Bahrain',
  bd: 'Bangladesh',
  bb: 'Barbados',
  by: 'Belarus',
  be: 'Belgium',
  bz: 'Belize',
  bj: 'Benin',
  bt: 'Bhutan',
  bo: 'Bolivia',
  ba: 'Bosnia and Herzegovina',
  bw: 'Botswana',
  br: 'Brazil',
  bn: 'Brunei',
  bg: 'Bulgaria',
  bf: 'Burkina Faso',
  bi: 'Burundi',
  cv: 'Cabo Verde',
  kh: 'Cambodia',
  cm: 'Cameroon',
  ca: 'Canada',
  cf: 'Central African Republic',
  td: 'Chad',
  cl: 'Chile',
  cn: 'China',
  co: 'Colombia',
  km: 'Comoros',
  cg: 'Congo (Congo-Brazzaville)',
  cd: 'Congo (Democratic Republic)',
  cr: 'Costa Rica',
  hr: 'Croatia',
  cu: 'Cuba',
  cy: 'Cyprus',
  cz: 'Czechia',
  dk: 'Denmark',
  dj: 'Djibouti',
  dm: 'Dominica',
  do: 'Dominican Republic',
  ec: 'Ecuador',
  eg: 'Egypt',
  sv: 'El Salvador',
  gq: 'Equatorial Guinea',
  er: 'Eritrea',
  ee: 'Estonia',
  sz: 'Eswatini',
  et: 'Ethiopia',
  fj: 'Fiji',
  fi: 'Finland',
  fr: 'France',
  ga: 'Gabon',
  gm: 'Gambia',
  ge: 'Georgia',
  de: 'Germany',
  gh: 'Ghana',
  gr: 'Greece',
  gd: 'Grenada',
  gt: 'Guatemala',
  gn: 'Guinea',
  gw: 'Guinea-Bissau',
  gy: 'Guyana',
  ht: 'Haiti',
  hn: 'Honduras',
  hu: 'Hungary',
  is: 'Iceland',
  in: 'India',
  id: 'Indonesia',
  ir: 'Iran',
  iq: 'Iraq',
  ie: 'Ireland',
  il: 'Israel',
  it: 'Italy',
  jm: 'Jamaica',
  jp: 'Japan',
  jo: 'Jordan',
  kz: 'Kazakhstan',
  ke: 'Kenya',
  ki: 'Kiribati',
  kp: 'Korea (North)',
  kr: 'Korea (South)',
  kw: 'Kuwait',
  kg: 'Kyrgyzstan',
  la: 'Laos',
  lv: 'Latvia',
  lb: 'Lebanon',
  ls: 'Lesotho',
  lr: 'Liberia',
  ly: 'Libya',
  li: 'Liechtenstein',
  lt: 'Lithuania',
  lu: 'Luxembourg',
  mg: 'Madagascar',
  mw: 'Malawi',
  my: 'Malaysia',
  mv: 'Maldives',
  ml: 'Mali',
  mt: 'Malta',
  mh: 'Marshall Islands',
  mr: 'Mauritania',
  mu: 'Mauritius',
  mx: 'Mexico',
  fm: 'Micronesia',
  md: 'Moldova',
  mc: 'Monaco',
  mn: 'Mongolia',
  me: 'Montenegro',
  ma: 'Morocco',
  mz: 'Mozambique',
  mm: 'Myanmar (Burma)',
  na: 'Namibia',
  nr: 'Nauru',
  np: 'Nepal',
  nl: 'Netherlands',
  nz: 'New Zealand',
  ni: 'Nicaragua',
  ne: 'Niger',
  ng: 'Nigeria',
  mk: 'North Macedonia',
  no: 'Norway',
  om: 'Oman',
  pk: 'Pakistan',
  pw: 'Palau',
  ps: 'Palestine State',
  pa: 'Panama',
  pg: 'Papua New Guinea',
  py: 'Paraguay',
  pe: 'Peru',
  ph: 'Philippines',
  pl: 'Poland',
  pt: 'Portugal',
  qa: 'Qatar',
  ro: 'Romania',
  ru: 'Russia',
  rw: 'Rwanda',
  kn: 'Saint Kitts and Nevis',
  lc: 'Saint Lucia',
  vc: 'Saint Vincent and the Grenadines',
  ws: 'Samoa',
  sm: 'San Marino',
  st: 'Sao Tome and Principe',
  sa: 'Saudi Arabia',
  sn: 'Senegal',
  rs: 'Serbia',
  sc: 'Seychelles',
  sl: 'Sierra Leone',
  sg: 'Singapore',
  sk: 'Slovakia',
  si: 'Slovenia',
  sb: 'Solomon Islands',
  so: 'Somalia',
  za: 'South Africa',
  ss: 'South Sudan',
  es: 'Spain',
  lk: 'Sri Lanka',
  sd: 'Sudan',
  sr: 'Suriname',
  se: 'Sweden',
  ch: 'Switzerland',
  sy: 'Syria',
  tj: 'Tajikistan',
  tz: 'Tanzania',
  th: 'Thailand',
  tl: 'Timor-Leste',
  tg: 'Togo',
  to: 'Tonga',
  tt: 'Trinidad and Tobago',
  tn: 'Tunisia',
  tr: 'Turkey',
  tm: 'Turkmenistan',
  tv: 'Tuvalu',
  ug: 'Uganda',
  ua: 'Ukraine',
  ae: 'United Arab Emirates',
  gb: 'United Kingdom',
  us: 'United States of America',
  uy: 'Uruguay',
  uz: 'Uzbekistan',
  vu: 'Vanuatu',
  va: 'Vatican City',
  ve: 'Venezuela',
  vn: 'Vietnam',
  ye: 'Yemen',
  zm: 'Zambia',
  zw: 'Zimbabwe',
}

const countryOptions = entries(countryLabels).map(([key, value]) => ({
  value: key,
  label: value,
}))

const stateOptions = values(countryData)
  .map(value => keys(value).map(state => ({ value: state, label: state })))
  .flat()

const cityOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      keys(stateObj).map(city => ({ value: city, label: city })),
    ),
  )
  .flat(2)

const pincodeOptions = values(countryData)
  .map(countryObj =>
    values(countryObj).map(stateObj =>
      values(stateObj).map(pinArr =>
        pinArr?.map(pin => ({ value: pin, label: pin })),
      ),
    ),
  )
  .flat(3)

export {
  countryData,
  cityOptions,
  countryOptions,
  pincodeOptions,
  stateOptions,
  countryLabels,
  regionList,
}
